import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Hls from 'hls.js';

const propTypes = {
  src: PropTypes.string.isRequired,
  type: PropTypes.string,
  video: PropTypes.object,
};

export default class HLSSource extends Component {
  constructor(props, context) {
    super(props, context);
    this.hls = new Hls();
  }

  handleManifestParsed = () => {
    const { onManifestParsed } = this.props;
    if (onManifestParsed) {
      onManifestParsed()
    }
  };

  updateVideo = (props) => {
    // `src` is the property get from this component
    // `video` is the property insert from `Video` component
    // `video` is the html5 video element
    const { src, video, onManifestParsed } = props;
    // load hls video source base on hls.js
    if (Hls.isSupported()) {
      this.hls.loadSource(src);
      this.hls.attachMedia(video);
      this.hls.off(Hls.Events.MANIFEST_PARSED, this.handleManifestParsed);
      this.hls.on(Hls.Events.MANIFEST_PARSED, this.handleManifestParsed);
    }
  };

  componentDidMount() {
    this.updateVideo(this.props)
  }

  componentWillUnmount() {
    // destroy hls video source
    if (this.hls) {
      this.hls.destroy();
    }
  }

  componentDidUpdate(prevProps) {
    if(prevProps.src !== this.props.src) {
      this.updateVideo(this.props)
    }
  }

  render() {
    return (
      <source
        src={this.props.src}
        type={this.props.type || 'application/x-mpegURL'}
      />
    );
  }

}

HLSSource.propTypes = propTypes;
